// Toplama Ekranı (el terminali, ürün ürün toplama) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.picking';

export const wmsPickingGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Toplama nasıl yapılır?'),
  intro: t(`${G}.intro`, 'İş emrindeki ürünleri rafa gidip okutarak toplarsınız. Her doğru okutma ürünü raf stoğundan düşer; bu yüzden önce lokasyonu, sonra ürünü okutun. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'İlerleme, sepet, Listedeki ürünler'),
    form: t(`${G}.regions.form`, 'Harita ve Toplanacak Ürün'),
    list: t(`${G}.regions.list`, 'Okutma adımları'),
    footer: t(`${G}.regions.footer`, 'Atla / Stok Sorunu / Siparişi İptal Et'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Lokasyona gidin'),
      text: t(`${G}.s1.text`, 'Haritada gideceğiniz raf işaretlidir; "Toplanacak Ürün" kartında ürün adı, barkodu, lokasyonu ve miktarı yazar. Rota seçenekleri (Optimal, Sol Öncelikli, Sağ Öncelikli) arasında geçiş yapabilirsiniz. Üstteki çubuk toplanan / toplam ürün sayısını gösterir.'),
      tips: [
        t(`${G}.s1.tip1`, '"Listedeki ürünler" düğmesi iş emrindeki tüm ürünleri açar; sıra dışı toplamak için listeden seçin ya da başka bir lokasyonun veya ürünün barkodunu okutun, ekran o ürüne geçer.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Lokasyon barkodunu okutun'),
      text: t(`${G}.s2.text`, '"Adım 1: Lokasyon Barkodunu Okutun" kutusuna raftaki etiketi okutun. Ürün başka bir rafta da duruyorsa o raf da kabul edilir ("Farklı lokasyon kabul edildi"). Tanınmayan barkodda uyarı çıkar, tekrar okutun.'),
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Ürünü okutun, miktarı onaylayın'),
      text: t(`${G}.s3.text`, '"Adım 2: Ürün Barkodunu Okutun" kutusuna ürünü okutun. Yanlış ürünse "Yanlış ürün!" uyarısı çıkar. Miktar 1 ise ürün hemen toplanır; fazlaysa "Adım 3"te miktarı girip "Onayla"ya basın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Toplanan miktar okuttuğunuz lokasyonun stoğundan düşülür ve stok hareketi yazılır. Lokasyondaki stok yetmiyorsa toplama kaydedilmez; "Stok Sorunu"nu kullanın.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Lokasyonu olmayan ürün'),
      text: t(`${G}.s4.text`, '"Bu ürünün tanımlı lokasyonu yok" kutusu çıkarsa önerilen lokasyonu "Bu lokasyona ata" ile onaylayın ya da lokasyon barkodunu okutup / kodu yazıp "Ata"ya basın. Ürünün depoda rafsız duran stoğu o rafa taşınır, sonra normal okutmaya dönersiniz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Taşınacak rafsız stok yoksa "Yerinde mal kabul yap" ile rafa stok girmeniz istenir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Stok sorunu bildirin'),
      text: t(`${G}.s5.text`, 'Ürün rafta yoksa veya eksikse "Stok Sorunu"na basın ve birini seçin:'),
      tips: [
        t(`${G}.s5.tip1`, 'Yerinde mal kabul yap (stok gir): girdiğiniz miktar o lokasyonun stoğuna eklenir ve stok hareketi yazılır. Sonra lokasyonu okutup ürünü normal toplayın.'),
        t(`${G}.s5.tip2`, 'Kısmi topla (kalanı eksik bırak): bulduğunuz miktarı girin; kalem eksik toplandı (short pick) olarak kapanır.'),
        t(`${G}.s5.tip3`, 'Ürünü atla: kalem hiç toplanmadan eksik (short pick) olarak kapanır.'),
        t(`${G}.s5.tip4`, 'Alttaki "Atla" düğmesi hiçbir şey kaydetmez; yalnız sıradaki ürüne geçer, atlanan ürün listede bekler. Toplanmamış veya stok sorunu bildirilmemiş ürün kaldıkça iş emri tamamlanmaz; ekran toplamaya geri döner.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Siparişi iptal edin'),
      text: t(`${G}.s6.text`, '"Siparişi İptal Et" ekrandaki ürünün siparişini iptal eder: iptal sebebini seçin (ör. ürün lokasyonda bulunamadı, ürün hasarlı), isterseniz açıklama yazıp "İptal Bildirimi Gönder"e basın. Sipariş İptal Yönetimi kuyruğuna düşer ve iş emrindeki diğer siparişlerle devam edersiniz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Bu siparişten o ana kadar toplanmış ürünler stoğa geri eklenir. Sipariş e-ticaretten geldiyse orada da iptal edilir.'),
        t(`${G}.s6.tip2`, 'Paketlenmiş veya kargolanmış sipariş buradan iptal edilemez.'),
      ],
    },
  ],
});
